export class Organization {
  UserPoolId: string;
  OrganizationId: string;
  ClientId: string;
  OrganizationName: string;
  Facilities: any[];
  Applications: any[];
  Panels: any[];
}
